import { render } from "./SpacerComponents.vue?vue&type=template&id=6ee9b0f4"
import script from "./SpacerComponents.vue?vue&type=script&lang=js"
export * from "./SpacerComponents.vue?vue&type=script&lang=js"

import "./SpacerComponents.vue?vue&type=style&index=0&id=6ee9b0f4&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/Genesii/COLON/wonderful-colon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__